// Copyright (c) StrangeBee 2024

import React, { ReactElement, useContext, useEffect } from 'react';
import { useLocalMessage } from '@Helpers/';
import { THMarkdownContext } from '@Molecules/Inputs/THMarkdown/THMarkdown';

import './PluginPreview.scss';

//eslint-disable-next-line
export const PluginPreview = (props: any): ReactElement => {
    const i = useLocalMessage();

    const { viewMode = false, setViewMode } = useContext(THMarkdownContext);

    const handleClick = () => {
        setViewMode(!viewMode);
    };

    useEffect(() => {
        props.editor.setView({ md: !viewMode, html: viewMode, hideMenu: false });
    }, [viewMode, props.editor]);

    return (
        <span className="plugin-preview" title="Preview" onClick={handleClick}>
            {viewMode ? i('app.markdown.editor.edit') : i('app.markdown.editor.preview')}
        </span>
    );
};

PluginPreview.align = 'right';
PluginPreview.pluginName = 'preview';
